(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["shejtano-case-offer"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('shejtano-case-offer')) return;
  let busy = false;
  const cartBusy = () => busy || document.documentElement.hasAttribute('data-shej-cart-busy') || Boolean(document.querySelector('.cart__items--disabled'));
  const root = () => window.Shopify?.routes?.root || '/';
  const signature = item => JSON.stringify([String(item.variant_id), Object.entries(item.properties || {}).sort(), item.selling_plan_allocation?.selling_plan?.id || null]);
  const request = async (path, data) => {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await fetch(path.startsWith('/') ? path : root() + path, {
        method: data ? 'POST' : 'GET', credentials: 'same-origin', signal: controller.signal,
        headers: { Accept: 'application/json', ...(data ? { 'Content-Type': 'application/json' } : {}) },
        ...(data ? { body: JSON.stringify(data) } : {})
      });
      const result = await response.json();
      if (!response.ok || result.status >= 400 || result.errors) {
        const error = new Error(typeof result.description === 'string' ? result.description : 'Cart request failed');
        error.confirmedFailure = true;
        throw error;
      }
      return result;
    } finally { clearTimeout(timeout); }
  };
  const sectionMap = () => {
    const result = [{ id: 'cart-drawer', target: '#CartDrawer', source: '#CartDrawer' }, { id: 'cart-icon-bubble', target: '#cart-icon-bubble', source: '.shopify-section' }];
    for (const id of ['main-cart-items', 'main-cart-footer']) {
      const element = document.getElementById(id);
      if (element?.dataset.id) result.push({ id: element.dataset.id, target: '#' + id + ' .js-contents', source: '.js-contents' });
    }
    return result;
  };
  const sectionPayload = () => ({ sections: sectionMap().map(s => s.id), sections_url: window.location.pathname });
  const renderSections = async (result, drawerOpen, focusId) => {
    const map = sectionMap();
    let sections = result.sections;
    if (map.some(s => document.querySelector(s.target) && typeof sections?.[s.id] !== 'string')) {
      sections = await request(window.location.pathname + '?sections=' + map.map(s => encodeURIComponent(s.id)).join(','));
    }
    const parser = new DOMParser();
    for (const section of map) {
      const target = document.querySelector(section.target);
      if (!target) continue;
      const source = parser.parseFromString(sections?.[section.id] || '', 'text/html').querySelector(section.source);
      if (!source) throw new Error('Missing cart section');
      target.innerHTML = source.innerHTML;
    }
    const cart = Number.isFinite(result.item_count) ? result : await request('cart.js');
    const empty = cart.item_count === 0;
    document.querySelectorAll('cart-drawer, cart-items, cart-drawer-items, #main-cart-footer').forEach(el => el.classList.toggle('is-empty', empty));
    const drawer = document.querySelector('cart-drawer');
    const overlay = drawer?.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', () => drawer.close());
    if (drawerOpen && drawer) {
      drawer.classList.add('active');
      const focus = (focusId && document.getElementById(focusId)) || drawer.querySelector('.drawer__close');
      if (typeof trapFocus === 'function') trapFocus(drawer.querySelector('.drawer__inner'), focus);
      else focus?.focus({ preventScroll: true });
    } else if (focusId) document.getElementById(focusId)?.focus({ preventScroll: true });
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: cart });
    return cart;
  };
  const displayError = (owner, message) => {
    let area = owner.isConnected ? owner.querySelector('[data-case-error]') : null;
    if (!area) area = document.querySelector('cart-drawer.active [data-case-error], #main-cart-items [data-case-error], #CartDrawer-CartErrors, #cart-errors');
    if (area) { area.textContent = message; area.hidden = false; }
  };
  const mutate = async (owner, action, focusId) => {
    if (cartBusy()) return false;
    busy = true;
    document.documentElement.setAttribute('data-shej-cart-busy', 'offer');
    const drawerOpen = Boolean(owner.closest('cart-drawer')?.classList.contains('active'));
    const controls = Array.from(document.querySelectorAll('cart-drawer button, cart-drawer input, cart-drawer select, cart-items button, cart-items input, cart-items select, #main-cart-footer button, #addButton')).map(el => [el, el.disabled]);
    controls.forEach(([el]) => { el.disabled = true; });
    document.querySelectorAll('[data-case-error]').forEach(el => { el.hidden = true; });
    owner.setAttribute('aria-busy', 'true');
    let writeStarted = false;
    let added = false;
    let removed = false;
    try {
      const result = await action({ writing: () => { writeStarted = true; }, added: () => { added = true; }, removed: () => { removed = true; } });
      await renderSections(result, drawerOpen, focusId);
      return true;
    } catch (error) {
      const message = added && !removed && owner.tagName === 'SHEJTANO-CASE-MODEL' ? owner.dataset.partial : writeStarted && !error.confirmedFailure ? owner.dataset.uncertain : owner.dataset.error;
      try { await renderSections(await request('cart.js'), drawerOpen, focusId); } catch {}
      displayError(owner, message);
      return false;
    } finally {
      owner.removeAttribute('aria-busy');
      controls.forEach(([el, disabled]) => { if (el.isConnected) el.disabled = disabled; });
      document.documentElement.removeAttribute('data-shej-cart-busy');
      busy = false;
    }
  };
  class CaseOffer extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-case-add]');
        if (!button || cartBusy()) return;
        event.preventDefault();
        event.stopPropagation();
        if (button.dataset.caseModel !== this.dataset.model) return;
        mutate(this, async phase => {
          phase.writing();
          const result = await request('cart/add.js', { items: [{ id: Number(button.dataset.caseAdd), quantity: 1 }], ...sectionPayload() });
          phase.added();
          return result;
        });
      });
      if (this.dataset.count !== '1') return;
      const drawer = this.closest('cart-drawer');
      if (!drawer || drawer.classList.contains('active')) this.load();
      else {
        this.observer = new MutationObserver(() => { if (drawer.classList.contains('active')) { this.observer.disconnect(); this.load(); } });
        this.observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
      }
    }
    disconnectedCallback() { this.observer?.disconnect(); this.controller?.abort(); }
    async load() {
      if (this.loaded || !this.isConnected) return;
      this.loaded = true;
      this.controller = new AbortController();
      const timer = setTimeout(() => this.controller.abort(), 12000);
      const area = this.querySelector('[data-case-cards]');
      try {
        const response = await fetch(this.dataset.url, { credentials: 'same-origin', signal: this.controller.signal, headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error('Recommendations unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const cards = html.querySelector('[data-case-recommendations]');
        if (!cards || !this.isConnected) return;
        area.replaceChildren(cards);
        if (!cards.querySelector('[data-case-add]')) area.hidden = true;
      } catch {
        if (area && this.isConnected) area.hidden = true;
      } finally { clearTimeout(timer); area?.setAttribute('aria-busy', 'false'); }
    }
  }
  class CaseModel extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('change', async event => {
        if (event.target.tagName !== 'SELECT') return;
        event.stopPropagation();
        const select = event.target;
        const nextId = Number(select.value);
        const oldId = Number(this.dataset.variant);
        if (cartBusy() || !nextId || nextId === oldId) { select.value = String(oldId); return; }
        const success = await mutate(this, async phase => {
          const before = await request('cart.js');
          const old = before.items.find(item => item.key === this.dataset.key);
          if (!old || old.variant_id !== oldId) throw new Error('Cart changed');
          const oldSignature = signature(old);
          const originalQuantity = before.items.filter(item => signature(item) === oldSignature).reduce((sum, item) => sum + item.quantity, 0);
          const payload = { id: nextId, quantity: old.quantity, properties: old.properties || {} };
          if (old.selling_plan_allocation) payload.selling_plan = old.selling_plan_allocation.selling_plan.id;
          const targetSignature = signature({ ...old, variant_id: nextId });
          const targetQuantity = before.items.filter(item => signature(item) === targetSignature).reduce((sum, item) => sum + item.quantity, 0);
          phase.writing();
          await request('cart/add.js', { items: [payload] });
          phase.added();
          const afterAdd = await request('cart.js');
          const originals = afterAdd.items.filter(item => signature(item) === oldSignature);
          const addedQuantity = afterAdd.items.filter(item => signature(item) === targetSignature).reduce((sum, item) => sum + item.quantity, 0);
          if (originals.reduce((sum, item) => sum + item.quantity, 0) !== originalQuantity || addedQuantity !== targetQuantity + old.quantity || afterAdd.item_count !== before.item_count + old.quantity) throw new Error('Cart changed');
          originals.sort((a, b) => Number(b.key === old.key) - Number(a.key === old.key));
          const updates = {};
          let remaining = old.quantity;
          for (const item of originals) {
            if (!remaining) break;
            const removedQuantity = Math.min(remaining, item.quantity);
            updates[item.key] = item.quantity - removedQuantity;
            remaining -= removedQuantity;
          }
          const result = await request('cart/update.js', { updates, ...sectionPayload() });
          phase.removed();
          if (result.item_count !== before.item_count || result.items.filter(item => signature(item) === oldSignature).reduce((sum, item) => sum + item.quantity, 0) !== originalQuantity - old.quantity || result.items.filter(item => signature(item) === targetSignature).reduce((sum, item) => sum + item.quantity, 0) !== targetQuantity + old.quantity) throw new Error('Cart changed');
          return result;
        }, select.id);
        if (!success && select.isConnected) select.value = String(oldId);
      });
    }
  }
  customElements.define('shejtano-case-offer', CaseOffer);
  customElements.define('shejtano-case-model', CaseModel);
})();
  } catch(e) { console.error(e); }
})();

})();
